import COMPONENT_DATA from './components/content.js';

(async function () {
  customElements.define(
    ('component-name' in document.currentScript.dataset?document.currentScript.dataset['component-name']:'dsb-content'),
    COMPONENT_DATA
  );
})();
